import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute, PublicOnlyRoute } from './components/ProtectedRoute';
import { RegisterPage } from './pages/RegisterPage';
import { VerifyPage } from './pages/VerifyPage';
import { CompleteProfilePage } from './pages/CompleteProfilePage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { DaftarPerusahaanPage } from './pages/DaftarPerusahaanPage';
import { LoginAplikasiPage } from './pages/LoginAplikasiPage';
import { AplikasiBookuPage } from './pages/AplikasiBookuPage';
import { ProfilPage } from './pages/ProfilPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Publik — hanya saat belum login */}
          <Route
            path="/register"
            element={
              <PublicOnlyRoute>
                <RegisterPage />
              </PublicOnlyRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicOnlyRoute>
                <LoginPage />
              </PublicOnlyRoute>
            }
          />

          {/* Publik — akses bebas */}
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/lengkapi-profil" element={<CompleteProfilePage />} />

          {/* Protected — butuh login */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/perusahaan/daftar"
            element={
              <ProtectedRoute>
                <DaftarPerusahaanPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aplikasi"
            element={<Navigate to="/aplikasi/booku" replace />}
          />
          <Route
            path="/aplikasi/booku"
            element={
              <ProtectedRoute>
                <AplikasiBookuPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aplikasi/login"
            element={
              <ProtectedRoute>
                <LoginAplikasiPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil"
            element={
              <ProtectedRoute>
                <ProfilPage />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
